import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import axios from 'axios';
import { getTokenFromStorage } from '../utility/common-logic';
import {
  bypassedApisWithEndpoint,
  bypassedApisWithoutEndpoint,
} from '../utility/static-data/bypassed-apis';
import { NetworkWarningDialogService } from './network-warning-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class AxiosService {
  constructor(
    private translate: TranslateService,
    private networkWarningService: NetworkWarningDialogService,
  ) {}

  configureAxios() {
    const bypassedApis = bypassedApisWithEndpoint;

    axios.interceptors.request.use(
      (req) => {
        const token = getTokenFromStorage();
        const isBypassedUrl =
          bypassedApis.some((url) => req.url.includes(url)) ||
          bypassedApis.includes(req.url);
        if (isBypassedUrl) {
          return req;
        } else if (!!token) {
          return req;
        }
        return Promise.reject(
          new Error(this.translate.instant('authentication.expiredSession')),
        );
      },
      (err) => {
        return Promise.reject(err);
      },
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        // Do something with successful responses
        return response;
      },
      (error) => {
        // Handle errors
        if (error?.response?.status === 401) {
          const requestUrl = error?.config?.url || '';
          const isBypassedAuthApi = bypassedApisWithoutEndpoint.some((api) =>
            requestUrl.includes(api),
          );

          if (!isBypassedAuthApi) {
            localStorage.removeItem('token-auth');
            window.location.href = '/login';
          }
        }
        if (error?.response?.status === 418) {
          this.networkWarningService.openNetworkWarningDialog();
        }
        return Promise.reject(error);
      },
    );
  }
}
